import { render, staticRenderFns } from "./cust_booking_details_component.vue?vue&type=template&id=82a8d3f2&"
import script from "../../assets/customer/js/cust_bookingdetails.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/cust_bookingdetails.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports